import { useEffect, useState } from 'react'

import { Provider } from './context'

interface AccordionProps {
  children: React.ReactNode
  isActive?: boolean
}

const Accordion: React.FC<AccordionProps> = props => {
  const { children, isActive = false } = props
  const [active, setActive] = useState(false)

  useEffect(() => {
    setActive(isActive)
  }, [isActive])

  return (
    <Provider
      value={{
        active: active,
        toggle: () => setActive(!active)
      }}
    >
      {children}
    </Provider>
  )
}

export default Accordion
